import * as yup from "yup";

export interface Environment {
	id: string;
	name: string;
}

export interface ProductInstance {
	id: string;
	name: string;
}

export interface Component {
	id: string;
	name: string;
}

export interface ComponentInstance {
	id: string;
	name: string;
	componentId: string;
}

export interface OperationalConfiguration {
	operationalConfigurationId: string;
	productId: string;
	createdBy: string;
	createdDate: Date | string;
	defaultValue: string;
	description: string;
	displayName: string;
	updatedBy: string;
	lastUpdatedDate: Date | string;
	name: string;
	overrides: OperationalConfigurationOverride[];
}

export interface OperationalConfigurationOverride {
	operationalConfigurationOverrideId: string;
	operationalConfigurationId: string;
	productId: string;
	environmentId: string;
	environmentName: string;
	productInstanceName: string;
	productInstanceId: string;
	componentId: string;
	componentName: string;
	componentInstanceId: string;
	componentInstanceName: string;
	value: string;
	createdBy: string;
	createdDate: Date | string;
	lastUpdatedBy: string;
	lastUpdatedDate: Date | string;
}

export interface OperationalConfigurationEditRequest {
	operationalConfigurationId?: string;
	defaultValue: string;
	description: string;
	displayName: string;
	name: string;
}

export interface OperationalConfigurationOverrideEditRequest {
	operationalConfigurationOverrideId?: string;
	operationalConfigurationId: string;
	value: string;
	componentId?: string;
	componentInstanceId?: string;
	productInstanceId?: string;
	environmentId?: string;
}

export const OperationalConfigurationEditRequestInitialValue: OperationalConfigurationEditRequest = {
	operationalConfigurationId: "",
	defaultValue: "",
	description: "",
	displayName: "",
	name: "",
};

export const OperationalConfigurationOverrideEditRequestInitialValue: OperationalConfigurationOverrideEditRequest = {
	operationalConfigurationOverrideId: "",
	operationalConfigurationId: "",
	value: "",
	componentId: "",
	componentInstanceId: "",
	productInstanceId: "",
	environmentId: "",
};

export const OperationalConfigurationEditRequestValidationSchema = yup.object().shape({
	name: yup.string().required().max(250).label("name"),
	displayName: yup.string().required().max(250).label("display name"),
	description: yup.string().required().max(2000).label("description"),
	defaultValue: yup.string().required().label("default value"),
});

export const OperationalConfigurationOverrideEditRequestValidationSchema = yup.object().shape({
	value: yup.string().required().label("value"),
});
